import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./components/css/layout.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { LanguageProvider } from "providers/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <LanguageProvider>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
    </LanguageProvider>
);

reportWebVitals();
